export const LANGUAGES: Record<string, string> = {
    'en': 'English',
    'fr': 'French',
    'es': 'Spanish',
    'ar': 'Arabic',
    'zh': 'Chinese',
    'pt': 'Portuguese',
    'ru': 'Russian',
    'sw': 'Swahili',
    'hi': 'Hindi',
    'bn': 'Bengali',
    'de': 'German',
    'el': 'Greek',
    'it': 'Italian',
    'lt': 'Lithuanian',
    'vi': 'Vietnamese',
    'nl': 'Dutch',
    'pl': 'Polish',
    'tr': 'Turkish',
    'ja': 'Japanese',
    'ko': 'Korean',
    'ro': 'Romanian',
    'ca': 'Catalan',
};
